var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        width: "100%",
        overflow: "scroll",
        height: "calc(100vh - 64px)"
      }
    },
    [
      _c(
        "div",
        { staticClass: "firstPage" },
        [
          _c("div", { staticClass: "firstPage-top" }, [
            _c("span", { staticClass: "firstPage-top-title" }, [
              _vm._v(" 智能合规平台，新一代数字化合规管理 ")
            ]),
            _c("span", { staticClass: "firstPage-top-desc" }, [
              _vm._v(" 线下工作线上化，线上工作系统化、标准化和智能化 ")
            ]),
            _c(
              "div",
              { staticClass: "firstPage-top-search" },
              [
                _c(
                  "div",
                  {
                    staticClass: "firstPage-top-search-sysList",
                    staticStyle: { "margin-bottom": "10px" }
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "firstPage-top-search-sysList-item",
                        class: { activeClass: _vm.activeName == "综合搜索" },
                        on: {
                          click: function($event) {
                            return _vm.setSystem("")
                          }
                        }
                      },
                      [_vm._v(" 综合搜索 ")]
                    ),
                    _vm._l(_vm.systemList, function(item, key, index) {
                      return _c(
                        "span",
                        {
                          key: index,
                          staticClass: "firstPage-top-search-sysList-item",
                          class: { activeClass: _vm.activeName == item },
                          on: {
                            click: function($event) {
                              return _vm.setSystem(key)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(item) + " ")]
                      )
                    })
                  ],
                  2
                ),
                _c("SearchBoxNew", {
                  ref: "searchBoxNew",
                  attrs: {
                    systemId: _vm.systemId,
                    systemBaseUrl: _vm.systemBaseUrl
                  },
                  on: { searchCommon: _vm.searchTitle }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "firstPage-mid" }, [
            _c(
              "div",
              { staticClass: "firstPage-mid-title" },
              [
                _c("function-icon", { staticClass: "firstPage-mid-title-img" }),
                _c("span", { staticClass: "firstPage-mid-title-text" }, [
                  _vm._v(" 常用功能 ")
                ])
              ],
              1
            ),
            _c(
              "div",
              {
                staticClass: "firstPage-mid-list",
                staticStyle: { "justify-content": "space-between" }
              },
              [
                _vm._l(9, function(ele) {
                  return _c(
                    "div",
                    {
                      key: ele,
                      staticClass: "firstPage-mid-list-item",
                      on: {
                        click: function($event) {
                          _vm.commonList[ele - 1]
                            ? _vm.openIframe(_vm.commonList[ele - 1])
                            : ""
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { width: "64px", height: "64px" } },
                        [
                          _vm.commonList[ele - 1] &&
                          _vm.commonList[ele - 1].functionIcon
                            ? _c("remote-img", {
                                staticStyle: { "margin-right": "10px" },
                                attrs: {
                                  width: "64px",
                                  height: "64px",
                                  icon: _vm.commonList[ele - 1].functionIcon
                                }
                              })
                            : _vm._e(),
                          _vm.commonList[ele - 1] &&
                          !_vm.commonList[ele - 1].functionIcon
                            ? _c("default-func-icon", {
                                staticStyle: { width: "64px", height: "64px" }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.commonList[ele - 1]
                        ? _c(
                            "div",
                            { staticClass: "firstPage-mid-list-item-text" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.commonList[ele - 1] &&
                                      _vm.commonList[ele - 1].resourceName
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                }),
                _c(
                  "div",
                  {
                    staticClass: "firstPage-mid-list-item",
                    on: { click: _vm.showComFunc }
                  },
                  [
                    _c("img", {
                      staticClass: "firstPage-mid-list-item-img",
                      attrs: { src: require("@/assets/addFunc.png") }
                    }),
                    _c("div", { staticClass: "firstPage-mid-list-item-text" }, [
                      _vm._v("更多")
                    ])
                  ]
                )
              ],
              2
            )
          ]),
          _c(
            "el-dialog",
            {
              staticClass: "dialog_footer_btn common",
              attrs: {
                title: "添加常用功能",
                visible: _vm.commonShow,
                width: "800px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.commonShow = $event
                },
                opened: _vm.openedMethod,
                closed: _vm.cancelClick
              }
            },
            [
              _c("div", { staticClass: "common-top" }, [
                _c("div", { staticClass: "common-top-title" }, [
                  _vm._v(" 功能名称 ")
                ]),
                _c(
                  "div",
                  { staticClass: "common-top-input" },
                  [
                    _c("el-input", {
                      staticStyle: { width: "280px", "margin-right": "20px" },
                      attrs: { placeholder: "请输入功能名称", clearable: "" },
                      on: {
                        input: function($event) {
                          _vm.funcName = _vm.funcName.replace(/\s+/g, "")
                        }
                      },
                      model: {
                        value: _vm.funcName,
                        callback: function($$v) {
                          _vm.funcName = $$v
                        },
                        expression: "funcName"
                      }
                    }),
                    _c("input", {
                      staticClass: "btn btn-red search-btn",
                      attrs: { type: "button", value: "查询" },
                      on: {
                        click: function($event) {
                          return _vm.searchForm()
                        }
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "common-bot" }, [
                _c("div", { staticClass: "common-bot-left" }, [
                  _c("div", { staticClass: "common-bot-left-title" }, [
                    _vm._v(" 可选择列表 ")
                  ]),
                  _c(
                    "div",
                    [
                      _c("el-tree", {
                        attrs: {
                          data: _vm.resourceList,
                          props: _vm.defaultProps
                        },
                        on: { "node-click": _vm.handleNodeClick }
                      })
                    ],
                    1
                  )
                ]),
                _c("div", { staticClass: "common-bot-right" }, [
                  _c("div", { staticClass: "common-bot-right-top" }, [
                    _c("div", { staticClass: "common-bot-right-title" }, [
                      _vm._v(" 已选择列表 ")
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "common-bot-right-clear",
                        staticStyle: { cursor: "pointer" },
                        on: { click: _vm.clearSelect }
                      },
                      [_vm._v(" 清除 ")]
                    )
                  ]),
                  _c(
                    "div",
                    { attrs: { id: "items" } },
                    _vm._l(_vm.selectResourceList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "common-bot-right-resourceList",
                          attrs: { "data-no": item.id }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "common-bot-right-resourceList-title"
                            },
                            [_vm._v(" " + _vm._s(item.resourceName) + " ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "common-bot-right-resourceList-close",
                              staticStyle: {
                                display: "flex",
                                "justify-content": "center",
                                "align-items": "center",
                                width: "20px",
                                height: "20px",
                                overflow: "hidden",
                                cursor: "pointer"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.delComFunc(item)
                                }
                              }
                            },
                            [
                              _c("wrong-icon", {
                                staticStyle: { width: "20px", height: "20px" }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]),
              _c("div", { staticClass: "common-footer" }, [
                _c("input", {
                  staticClass: "btn ",
                  staticStyle: { "margin-right": "20px" },
                  attrs: { type: "button", value: "取消" },
                  on: {
                    click: function($event) {
                      _vm.commonShow = false
                    }
                  }
                }),
                _c("input", {
                  staticClass: "btn btn-red",
                  attrs: { type: "button", value: "确认" },
                  on: { click: _vm.submitCom }
                })
              ])
            ]
          ),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" },
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.dashBoardShow,
                  expression: "dashBoardShow"
                }
              ],
              staticClass: "dialog_footer_btn common",
              attrs: {
                title: "添加图表",
                visible: _vm.dashBoardShow,
                width: "532px"
              },
              on: {
                "update:visible": function($event) {
                  _vm.dashBoardShow = $event
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "common-top", staticStyle: { height: "auto" } },
                [
                  _c("div", { staticClass: "common-top-title" }, [
                    _vm._v(" 可选择在首页查看的数据分析结果： ")
                  ]),
                  _c(
                    "div",
                    { staticClass: "common-top-dashboard" },
                    _vm._l(_vm.dashBoardList, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "common-top-dashboard-item"
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: item.selected,
                                callback: function($$v) {
                                  _vm.$set(item, "selected", $$v)
                                },
                                expression: "item.selected"
                              }
                            },
                            [_vm._v(_vm._s(item.dashboardName))]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                ]
              ),
              _c("div", { staticClass: "common-footer" }, [
                _c("input", {
                  staticClass: "btn ",
                  staticStyle: { "margin-right": "20px" },
                  attrs: { type: "button", value: "取消" },
                  on: { click: _vm.dashBoardCancel }
                }),
                _c("input", {
                  staticClass: "btn btn-red",
                  attrs: { type: "button", value: "确认" },
                  on: { click: _vm.submitDashBoard }
                })
              ])
            ]
          ),
          _c("task-container", {
            ref: "TaskContainer",
            on: { searchForm: _vm.searchForm }
          }),
          _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                title: _vm.todoTitle,
                visible: _vm.showDialog,
                top: "15vh",
                width: "570px",
                center: "",
                modal: ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.showDialog = $event
                }
              }
            },
            [
              _vm.showDialog
                ? _c("iframe", {
                    ref: "iframe",
                    staticClass: "task-container-iframe",
                    staticStyle: {
                      width: "100%",
                      "min-height": "505px",
                      border: "none"
                    },
                    attrs: { name: "iframe", src: _vm.dialogUrl }
                  })
                : _vm._e()
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }